import { m } from 'framer-motion';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { SimpleLayout } from 'src/layouts/simple';
import { DashboardLayout } from 'src/layouts/dashboard';
import { ForbiddenIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';

// ----------------------------------------------------------------------

type UnauthorizedViewProps = {
  /** 返回路径，默认商户后台首页 */
  backHref?: string;
  /** 内嵌于后台布局时使用，不套 SimpleLayout */
  embedded?: boolean;
};

/** 401 未授权页面 */
export function UnauthorizedView({ backHref, embedded = false }: UnauthorizedViewProps) {
  const router = useRouter();

  const handleBack = () => {
    router.replace(backHref ?? paths.auth.jwt.signIn);
  };

  const renderContent = (
    <>
      <m.div variants={varBounce('in')}>
        <Typography variant="h3" sx={{ mb: 2 }}>
          未授权
        </Typography>
      </m.div>

      <m.div variants={varBounce('in')}>
        <Typography sx={{ color: 'text.secondary', mb: 3 }}>
          您未授权访问此页面，请先登录。
        </Typography>
      </m.div>

      <m.div variants={varBounce('in')}>
        <ForbiddenIllustration sx={{ my: { xs: 5, sm: embedded ? 8 : 10 } }} />
      </m.div>
    </>
  );

  if (embedded) {
    return (
      <Container component={MotionContainer} sx={{ py: 10, textAlign: 'center' }}>
        {renderContent}
      </Container>
    );
  }

  return (
    <SimpleLayout slotProps={{ content: { compact: true } }}>
      <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
        {renderContent}
      </Container>
    </SimpleLayout>
  );
}
